export const PwaConstants = {
  /** How often to poll for a new deployment once the app has stabilised (30 minutes). */
  UpdateCheckIntervalMs: 30 * 60 * 1000,
} as const;
